export default {
  pageTitle: {
    id: 'bo_seller.kyb.legal_representative.page_title',
    defaultMessage: 'KYB - Legal representative details',
  },
  title: {
    id: 'bo_seller.kyb.legal_representative.title',
    defaultMessage: 'Legal representative details',
  },
  description: {
    id: 'bo_seller.kyb.legal_representative.description',
    defaultMessage:
      'Fill out details for the legal representative, that is, a person who has the authority to sign contracts on behalf of the business. Their name can be found in company filings.',
  },
  sameAsAccountRequesterLabel: {
    id: 'bo_seller.kyb.legal_representative.same_as_account_requester',
    defaultMessage:
      'Check this box if the legal representative is also the account requester.',
  },
  saveButton: {
    id: 'bo_seller.kyb.legal_representative.save_button',
    defaultMessage: 'Save',
  },
  saveSuccessTitle: {
    id: 'bo_seller.kyb.legal_representative.save_success_title',
    defaultMessage: 'Legal representative details saved ✔️',
  },
  saveSuccessContent: {
    id: 'bo_seller.kyb.legal_representative.save_success_content',
    defaultMessage: 'Nice work.',
  },
  saveErrorTitle: {
    id: 'bo_seller.kyb.legal_representative.save_error_title',
    defaultMessage: "Legal representative details weren't saved.",
  },
  savingLegalRepresentativeDetails: {
    id: 'bo_seller.kyb.legal_representative.saving_legal_representative_details',
    defaultMessage: 'Saving legal representative details...',
  },
  loadingLegalRepresentativeDetails: {
    id: 'bo_seller.kyb.legal_representative.loading_legal_representative_details',
    defaultMessage: 'Loading legal representative details...',
  },
} as const
